module.exports = __webpack_public_path__ + "img/feather-sprite.d225700.svg";